"use strict";


const axios = require('axios');


class Contact{
    constructor(){

    }

    static get_form_contact(){
        return{
            post : null,
            region : null,
            first_name : null,
            last_name : null,
            address : null,
            adress_secondary : null,
            postcode : null,
            city : null,
            country : null,
            website : null,
            keywords : [],
            twitter_link: null,
            facebook_link : null,
            instagram_link : null,
            linkedin_link : null,
            email : null,
            phone : null,
            commercial_assigned:null,
            is_active: true,
        }
    }

    static async get_contacts(){
        let contacts
        await axios({
            method: "get",
            url:
              process.env.VUE_APP_REPOSITORY +
              "contacts/",
        })
        .then((response) => {
            contacts = response.data.results;
        })
        .catch((error) => {
            console.log(error);
        });
        return contacts ;
    }

    static async get_contacts_with_request(request) {
        let contacts;
        let rows;
        await axios({
            method: "get",
            url:process.env.VUE_APP_REPOSITORY + "contacts/" + request,
        })
            .then((response) => {
                contacts = response.data.results;
                rows = response.data.count;
            })
            .catch((error) => {
                console.log(error);
            });
        return [contacts, rows];
    }

    static async get_contacts_by_organization(id_organization){
        let contacts
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_REPOSITORY +
                "contacts/?organization=" +  id_organization,
        })
            .then((response) => {
                contacts = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return contacts ;
    }

    static get_contact_type_choices() {
        return [
            { value: "organisation", text: "Organisation" },
            { value: "contact", text: "Contact" },
            { value: "provider", text: "Fournisseur" }
          ]
    }
    static get_contact_user_categorie_choices() {
        return [
            { value: "comptable", text: "Comptable" },
            { value: "collaborateur", text: "Collaborateur" },
            { value: "cdp", text: "Chefs de Projets" },
            { value: "rh", text: "Ressources Humaines" }
          ]
    }

    static get_contact_user_categories_filter_choices() {
        return [
            { value: "all", text: "Tous" },
            { value: "comptable", text: "Comptable" },
            { value: "collaborateur", text: "Collaborateur" },
            { value: "cdp", text: "Chefs de Projets" },
            { value: "rh", text: "Ressources Humaines" }
          ]
    }

    static async get_contact_by_id(id){
        let contact
        await axios({
            method: "get",
            url:
              process.env.VUE_APP_REPOSITORY +
              "contacts/" + id,
        })
        .then((response) => {
            contact = response.data;
        })
        .catch((error) => {
            console.log(error);
        });
        return contact ;
    }

    static async create_contact(form_contact){
        let contacts
        await axios({
            method: "post",
            url:
              process.env.VUE_APP_REPOSITORY +
              "contacts/",
            data : form_contact
        })
        .then((response) => {
            contacts = response.data;
        })
        .catch((error) => {
            console.log(error);
        });
        return contacts ;
    }

    static async delete_contact(id){
        await axios({
            method: "delete",
            url:
              process.env.VUE_APP_REPOSITORY +
              "contacts/" + id,
        })
        .then((response) => {
            return response 
        })
        .catch((error) => {
            console.log(error);
        });
    }

    static async edit_contact(id, form_contact){
        await axios({
            method: "put",
            url:
              process.env.VUE_APP_REPOSITORY +
              "contacts/" + id + "/",
            data : form_contact
        })
        .then((response) => {
            return response 
        })
        .catch((error) => {
            console.log(error);
        });
    }
}

class Address {
    static get_form() {
        return {
            address: null,
            postcode:null,
            city:null,
            country:null,
            default:false,
        }
    }

}


class Contact_document{
    static get_form_document(){
        return {
            contact: null,
            document: null,
            title: null,
            size: 0,
            created_at: null,
        }
    }

    static async create_document(form){
        let document_note ;
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_REPOSITORY  + "contact-documents/",
            data: form,
        })
        .then((response) => {
            document_note = response.data;
        })
        .catch((error) => {
            console.log(error);
        })
        return document_note ;
    }

    static async get_documents(id_contact){
        let documents;
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_REPOSITORY  + "contact-documents/?contact=" + id_contact,
        })
        .then((response) => {
            documents = response.data.results;
        })
        .catch((error) => {
            console.log(error);
        })
        return documents;
    }


    static async delete_document(id_document){
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_REPOSITORY  + "contact-documents/" + id_document,
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        })
    }
}

class Contact_note{
    static get_form_note(){
        return {
            contact: null,
            text: null, 
            pin: false,
            created_at: null,
        }
    }

    static async create_note(form){
        let note_form ;
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_REPOSITORY  + "contact-notes/",
            data: form,
        })
        .then((response) => {
            note_form = response.data;
        })
        .catch((error) => {
            console.log(error);
        })
        return note_form ;
    }

    static async get_notes(id_contact){
        let notes;
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_REPOSITORY  + "contact-notes/?contact=" + id_contact,
        })
        .then((response) => {
            notes = response.data.results;
            //console.log( notes)
        })
        .catch((error) => {
            console.log(error);
        })
        return notes;
    }

    static async edit_note(id_note, form){
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_REPOSITORY  + "contact-notes/" + id_note + "/",
            data : form,
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        })
    }

    static async delete_note(id_note){
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_REPOSITORY  + "contact-notes/" + id_note,
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        })
    }
}

class Organization{
    constructor(){

    }

    static get_form_organization(){
        return{
            type : null,
            company_name : null,
            region : null,
            address : null,
            postcode : null,
            city : null,
            country : null,
            email : null,
            phone : null,
            website : null,
            keywords : [],
            twitter_link : null,
            facebook_link : null,
            instagram_link : null,
            linkedin_link : null,
            vat_number : null,
            intracommunity_vat_number :null,
            siret_number : null,
            currency : null,
            default_price : null,
            default_tax : null,
            default_discount : null,
            default_tax_type : null,
            is_manufacturer : false,
            references : null,
            discount : 0,
            payday : 1,
            payment_method : null,
            display_commercial_name : null,
            display_county : null,
            deadline : null,
            sale_tax : null,
            sku:null,
            buy_tax : null,
            is_person: false,
            iban: null,
            bic: null,
            is_active: true,
            invoice_policy: null,
        }
    }

    static get_organization_category_choices(){
        return[
            {value : "comptable" , text : "Comptable"},
            {value : "collaborateur" , text : "Collaborateur"},
            {value : "rh" , text : "Ressources Humaines"},
            {value : "cdp" , text : "Chefs de Projets"},
        ]
    }

    static get_organization_type_choices(){
        return[
            {value : "client", text : "Client"},
            {value : "lead", text : "Lead"},
            {value : "prospect", text : "Prospect"},
            {value : "manufacturer", text : "Fournisseur"},
        ]
    }

    static get_organization_type_particular_choices(){
        return[
            {value : "client", text : "Client"},
            {value : "lead", text : "Lead"},
            {value : "prospect", text : "Prospect"},
        ]
    }

    static get_organization_type_filter_chocies(){
        return[
            {value : "all", text : "Tout"},
            {value : "client", text : "Client"},
            {value : "prospect", text : "Prospect"},
            {value : "manufacturer", text : "Fournisseur"},
        ]
    }

    static get_currency_choices(){
        return[
            {value : "eur", text : "EUR"},
            {value : "usd", text : "USD"},
        ]
    }

    static get_payment_method_choices() {
        return [
            {text: "CB", value: "cb"},
            {text: "Chèque", value: "bank_check"},
            {text: "Espèces", value: "cash"},
            {text: "Virement bancaire", value: "bank_transfer"},
        ]
    }

    static get_source_choices(){
        return [
            {text:"Linkedin", value:"linkedin"},
            {text:"Instagram", value:"instagram"},
            {text:"Facebook", value:"facebook"},
            {text:"Twitter", value:"twitter"},
            {text:"Site internet", value:"website"},
            {text:"Événements physiques", value:"physic_event"},
            {text:"Événements virtuels", value:"virtual_event"},
            {text:"SEA", value:"sea"},
            {text:"Communication physique", value:"communication"},
            {text:"Inbound marketing", value:"marketing"},
            {text:"Emailing", value:"emailing"},
            {text:"Autre", value:"other"},
        ]
    }

    static async create_organization(form){
        let organization_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_REPOSITORY + "organizations/",
            data: form,
        })
        .then((response) => {
            organization_form =  response.data;
        })
        .catch((error) => {
            console.log(error);
        })
        return organization_form
    }

    static async get_organizations(){
        let organizations;
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_REPOSITORY + "organizations/"
        })
        .then((response) => {
            organizations = response.data.results;
        })
        .catch((error) => {
            console.log(error);
        })
        return organizations;
    }

    static async get_organization_by_id(id){
        let organization;
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_REPOSITORY + "organizations/" + id,
        })
        .then((response) => {
            organization = response.data;
        })
        .catch((error) => {
            console.log(error);
        })
        return organization;
    }

    static async get_organizations_with_request(request) {
        let organizations;
        let rows;
        await axios({
            method: "get",
            url:process.env.VUE_APP_REPOSITORY + "organizations/" + request,
        })
            .then((response) => {
                organizations = response.data.results;
                rows = response.data.count;
            })
            .catch((error) => {
                console.log(error);
            });
        return [organizations, rows];
    }

    static async edit_organization(id_organization, form){
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_REPOSITORY + "organizations/" + id_organization + "/",
            data : form,
        })
        .then((response) => {

        })
        .catch((error) => {
            console.log(error);
        })
    }

    static async delete_organization(id_organization){
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_REPOSITORY + "organizations/" + id_organization,
        })
        .then((response) => {
        })
        .catch((error) => {
            console.log(error);
        })
    }
}

class Organization_document{
    static get_form_document(){
        return {
            contact: null,
            document: null,
            title: null,
            size: 0,
            created_at: null,
        }
    }

    static async create_document(form){
        let document_form ;
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_REPOSITORY  + "organization-documents/",
            data: form,
        })
            .then((response) => {
                document_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            })
        return document_form ;
    }

    static async get_documents_by_organization_id(id_organization){
        let documents;
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_REPOSITORY  + "organization-documents/?organization=" + id_organization,
        })
            .then((response) => {
                documents = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            })
        return documents;
    }


    static async delete_document(id_document){
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_REPOSITORY  + "organization-documents/" + id_document,
        })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error);
            })
    }
}

class Organization_note{
    static get_form_note(){
        return {
            contact: null,
            text: null,
            pin: false,
            created_at: null,
        }
    }

    static async create_note(form){
        let note_form ;
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_REPOSITORY  + "organization-notes/",
            data: form,
        })
            .then((response) => {
                note_form =  response.data;
            })
            .catch((error) => {
                console.log(error);
            })
        return note_form ;
    }

    static async get_notes_by_organization_id(id_organization){
        let notes;
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_REPOSITORY  + "organization-notes/?organization=" + id_organization,
        })
            .then((response) => {
                notes = response.data.results;
                //console.log( notes)
            })
            .catch((error) => {
                console.log(error);
            })
        return notes;
    }

    static async edit_note(id_note, form){
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_REPOSITORY  + "organization-notes/" + id_note + "/",
            data : form,
        })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error);
            })
    }

    static async delete_note(id_note){
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_REPOSITORY  + "organization-notes/" + id_note,
        })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error);
            })
    }
}


module.exports.Contact = Contact ;
module.exports.Address = Address ;
module.exports.Contact_note = Contact_note ;
module.exports.Contact_document = Contact_document ;
module.exports.Organization = Organization ;
module.exports.Organization_document = Organization_document ;
module.exports.Organization_note = Organization_note ;